import { combineReducers } from "redux";
import user from "./usersReducer";
import theme from "./themeReducer";
import businesses from "./businessReducer";
import selections from "./selectionsReducer";

const reducers = combineReducers({
    user,
    theme,
    businesses,
    selections
});

export default reducers;